export const REF_ARRAY_DATA_TYPE = 'RefArray'
export const CLASSIC_LAYOUT_TYPE = 'ClassicLayout'
